<template>
  <div class="display min-h-100 p-4 bg-dark text-white position-relative">
    <div class="toolbar bg-dark d-flex shadow align-items-center" :class="{ 'position-fixed': !sender, 'position-absolute': sender }">
      <div class="mr-2">Text size</div>
      <div class="text-size-selector">
        <div class="btn-group">
          <button type="button" class="btn btn-lg btn-outline-secondary" @click="decreaseFontSize()" :disabled="fontSize == 0">-</button>
          <button type="button" class="btn btn-lg btn-outline-secondary" @click="increaseFontSize()">+</button>
        </div>
      </div>

      <div class="clock text-right ml-auto">
        {{ clock }}
      </div>
    </div>

    <div class="d-flex flex-column h-100" style="padding-top: 120px;" :style="{ 'font-size': currentFontSize }">
      <div class="flex-fill d-flex align-items-center">
        <div v-html="messageText"></div>
      </div>
    </div>
  </div>
</template>

<script>
  import { firebase } from "@/initializers/firebase"
  
  export default {
    name: "display",
    props: {
      sender: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        message: null,
        now: this.$DateTime.local(),
        clockInterval: null,
        fontSize: 2
      }
    },
    computed: {
      clock() {
        return this.now.toFormat("HH:mm:ss")
      },
      messageText() {
        return (this.message && this.message.text ? this.message.text : "").replaceAll("\n", "<br>")
      },
      currentFontSize() {
        if(this.fontSize) {
          return `${this.fontSize}rem`
        } else {
          return `2rem`
        }
      }
    },
    methods: {
      startClock() {
        this.clockInterval = setInterval(this.runClock, 1000)
      },
      runClock() {
        this.now = this.$DateTime.local()
      },
      initLocalStorage() {
        const storage = window.localStorage.getItem("jaws-nanocom-app")
        if(!storage) {
          window.localStorage.setItem("jaws-nanocom-app", JSON.stringify({}))
        }
      },
      setFontSize() {
        const storage = window.localStorage.getItem("jaws-nanocom-app")
        const lsData = JSON.parse(storage)

        if(lsData.fontSize) {
          this.fontSize = parseInt(lsData.fontSize)
        } else {
          this.fontSize = 2
        }
      },
      increaseFontSize() {
        const storage = window.localStorage.getItem("jaws-nanocom-app")
        let lsData = JSON.parse(storage)
        
        let fontSize = (parseInt(this.fontSize) + 1)
        lsData.fontSize = fontSize

        window.localStorage.setItem("jaws-nanocom-app", JSON.stringify(lsData))

        this.setFontSize()
      },
      decreaseFontSize() {
        const storage = window.localStorage.getItem("jaws-nanocom-app")
        let lsData = JSON.parse(storage)

        let fontSize = (parseInt(this.fontSize) - 1)

        if(fontSize > 0) {
          lsData.fontSize = fontSize

          window.localStorage.setItem("jaws-nanocom-app", JSON.stringify(lsData))

          this.setFontSize()
        }
      }
    },
    async mounted() {
      this.initLocalStorage()
      this.setFontSize()

      clearInterval(this.clockInterval)
      this.startClock()

      let app = await firebase.firestore().collection(`app`)
      await this.$bind("message", app.doc(`message`))
    }
  }
</script>

<style scoped lang="scss">
  // .text-size-selector { top: 20px; left: 20px; }
  .toolbar { top: 0; left: 0; right: 0; padding: 20px; }
  .clock { font-size: 3rem; }
  // .clock { top: 20px; right: 20px; }
</style>
